export const flightTrackingConstants = {
    JOURNEY: {
      TITLE_PREFIX: 'Your trip to',
      FLIGHT_STATUS_TITLE:'Flight status',
      UPDATED_PREFIX: 'Updated',
    },
    WARNING: {
      LAST_SEGMENT_CANCELLED: (arrivalCity: string) => `Your ${arrivalCity} flight has been cancelled by the airline`,
      JOURNEY_CANCELLED: 'This journey has been cancelled by the airline',
      JOURNEY_CANCELLED_BY_USER: 'The journey has been cancelled as requested by user.',
      CANCELLATION_IMPACT: (departCity: string, arrivalCity: string) =>
        `Cancellation of your ${departCity} flight may impact your journey to ${arrivalCity}`,
      DELAY_IMPACT: (departCity: string, arrivalCity: string) =>
        `Delay in your ${departCity} flight may impact your journey to ${arrivalCity}`,
      DELAY_IMPACT_GENERIC: 'Flight delay may impact your journey',
    },
    DISCLAIMER: {
      LABEL: 'Disclaimer:',
      TEXT: 'Reconfirm flight timings with the airline and arrive 3–4 hours before departure.\nCleartrip assumes no liability for losses due to inconsistency in the above information.',
    },
    CHECK_IN: {
      TIME_NOTICE: 'Check-in might close at usual time',
    },
  }
  
  export const trackingPageConstants = {
    PAGE: {
      TITLE: 'Flight Tracking - Cleartrip',
      META_DESCRIPTION: 'Track your flight in real-time',
      SEARCH_TITLE: 'Track Flight - Search',
      SEARCH_META_DESCRIPTION: 'Search and track your flight status in real-time',
    },
    ERROR: {
      MISSING_FLIGHT_TRACKER_ID: 'Missing required parameter: flightTrackerId is required',
      MISSING_TRIP_PARAMS: 'Missing required parameters: tripId and journeyId are required',
      DATA_NOT_FOUND: 'Flight tracking data not found',
      FETCH_FAILED: 'Failed to fetch flight tracking data',
      FETCH_ERROR: 'An error occurred while fetching flight tracking data',
      NO_DATA_AVAILABLE: 'No flight tracking data available',
      UNABLE_TO_LOAD: 'Unable to load flight tracking information',
      CANCEL_PERMISSION_DENIED:
        'You do not have the permission to cancel this trip. Please connect with the person who booked the trip to make any changes to the trip.',
    },
    TRACK_FLIGHTS: 'Track flights',
    TRACK_FLIGHTS_IMAGE_URL:
    'https://rukmini-ct.flixcart.com/w_264,c_scale,q_1,f_auto,q_auto/staticresource-prod/images/cirium_flight_tracker.png',
    TRACK_FLIGHTS_PATH: '/flights/tracking/search',
  }

export const CIRIUM_ERROR_SCREEN_PATH = 'https://rukmini-ct.flixcart.com/q_100/staticresource-prod/cirium_error_screen.png'
export const CIRIUM_SOMETHING_WENT_WRONG_ERROR = 'Something went wrong'
export const CIRIUM_GO_BACK_LABEL = 'Go back'
export const constants = {
    CHECK_IN_UPDATE: {
      HEADING_TEXT: 'Check-in updates',
      DESCRIPTION:
        'The check-in counter may close at the usual time. Please arrive at the airport 3-4 hours before the scheduled departure.',
      DISCLAIMER_LABEL: 'Disclaimer: ',
      DISCLAIMER_TEXT: 'We keep flight info updated, but do check with your airline for accurate updates.',
      MODAL_WIDTH_PX: 312,
      MODAL_HEIGHT_PX: 212,
      MODAL_VIEWPORT_GUTTER_PX: 24,
    },
    HELP_CENTER: {
      HEADING_TEXT: 'Help centre',
      DESCRIPTION:
        'We apologize for the inconveniences, you can either cancel your flight to claim a refund by clicking on cancel booking and selecting the reason as Flight cancelled by Airlines or contact our support for assistance',
      PARTIAL_CANCELLATION_DESCRIPTION:
        'We apologize for the inconvenience. Please contact our support for further assistance.',
      DISCLAIMER_LABEL: 'Disclaimer: ',
      DISCLAIMER_TEXT: 'Kindly re-check with your airline for accurate information regarding your flight cancellation.',
      CANCEL_BOOKING_BUTTON: 'Cancel booking',
      CALL_US_BUTTON: 'Call us',
    },
    FLIGHT_TRACKING: {
      CANCELLED_BY_AIRLINE: 'Your flight is cancelled',
      LANDED: 'Landed',
      LANDED_ON_TIME: 'Landed on time',
      LANDING: 'Landing',
      LATE: ' late',
      DEPARTING: 'Departing ',
      DEPARTS_IN: 'Departs in ',
      GATE: 'Gate',
      BAGGAGE_CLAIM: 'Baggage claim',
      TERMINAL: 'Terminal',
      DELAYED: 'Delayed',
      EARLY: 'Early',
      ON_TIME: 'On time',
      BULLET_SEPARATOR: '•',
      PLACEHOLDER: '--',
    },
    CHECK_IN: {
      TIME_NOTICE: 'Check-in might close at usual time',
    },
    FLIGHT_TRACKER_CTA: {
      IMAGE_URL:
        'https://rukmini-ct.flixcart.com/w_264,c_scale,q_1,f_auto,q_auto/staticresource-prod/images/cirium_flight_tracker.png',
      PATH: '/flights/tracking/search',
    },
  }
  
  